import { Reveal } from "@/lib/motion";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({ onBook }) {
  const goAnalyze = () => document.getElementById("analyzer")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="relative z-10 py-24 md:py-32 overflow-hidden bg-brand">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(600px 300px at 20% 0%, rgba(255,255,255,0.5), transparent 60%)" }} />
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/70">What could your website become?</p>
          <h2 className="font-heading text-4xl md:text-6xl font-extrabold tracking-tight text-white leading-[1.05] mt-4">
            See what's wrong.<br />See what's possible.
          </h2>
          <p className="text-white/80 text-lg mt-6 max-w-xl mx-auto">
            Run a free WebsiteTech analysis and get an AI transformation plan in under a minute.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <button onClick={goAnalyze} data-testid="final-analyze-btn" className="bg-white text-brand font-semibold rounded-xl px-8 py-4 flex items-center gap-2 hover:-translate-y-0.5 transition-transform">
              Analyze Your Website <ArrowRight size={17} />
            </button>
            <button onClick={onBook} className="bg-white/10 text-white border border-white/30 font-semibold rounded-xl px-8 py-4 hover:bg-white/20 transition-colors">
              Book a Strategy Session
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
